import { CHANGE_PASS_ROUTE, DELETE_USER_ROUTE, EDIT_USER_ROUTE, REMOVE_USER_FROM_AGENCY_ROUTE } from '@/utils/CONST';
import extractIdFromURI from '@/utils/id';
import { Delete, Key } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import LogoutIcon from '@mui/icons-material/Logout';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router';

interface Props {
    userId: string;
}

const ActionField = ({ userId }: Props) => {
    const navigate = useNavigate();

    const extractedUserId = extractIdFromURI(userId);

    const navigateToChangePassword = () => {
        navigate(`${CHANGE_PASS_ROUTE}/${extractedUserId}`);
    };

    const navigateToEditUser = () => {
        navigate(`${EDIT_USER_ROUTE}/${extractedUserId}`);
    };

    const navigateToRemoveFromAgency = () => {
        navigate(`${REMOVE_USER_FROM_AGENCY_ROUTE}/${extractedUserId}`);
    };

    const navigateToDelete = () => {
        navigate(`${DELETE_USER_ROUTE}/${extractedUserId}`);
    };

    const buttons = [
        {
            icon: <Key />,
            onClick: navigateToChangePassword,
        },
        {
            icon: <EditIcon />,
            onClick: navigateToEditUser,
        },
        {
            icon: <LogoutIcon />,
            onClick: navigateToRemoveFromAgency,
        },
        {
            icon: <Delete />,
            onClick: navigateToDelete,
        },
    ];

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: `repeat(${buttons.length}, 1fr)`,
            }}
        >
            {buttons.map(({ icon, onClick }, index) => (
                <IconButton key={index} onClick={onClick} color={'primary'}>
                    {icon}
                </IconButton>
            ))}
        </Box>
    );
};

export default ActionField;
